module.exports = __webpack_public_path__ + "img/without-en.0939ea8c.jpg";